<div>

  <section class="form-tasklist">
    <mat-accordion class="retrofit-headers-align">

      <!--Contractor info-->
      <mat-expansion-panel
        [expanded]="viewApprovalTask === 0"
        (opened)="setApprovalTask(0)">
          <mat-expansion-panel-header
            [collapsedHeight]="'60px'"
            [expandedHeight]="'60px'">
              <mat-panel-title>
                <div [ngSwitch]="taskRetrofitContractorStatus.toLowerCase()">
                  <mat-icon *ngSwitchCase="'pending'" class="retrofit-task-icon primary"><i class="fa-solid fa-square-poll-horizontal fa-sm"></i></mat-icon>
                  <mat-icon *ngSwitchCase="'selected'" class="retrofit-task-icon accepted"><i class="fa-solid fa-square-check fa-sm"></i></mat-icon>
                  <mat-icon *ngSwitchCase="'rejected'" class="retrofit-task-icon rejected"><i class="fa-solid fa-triangle-exclamation fa-sm"></i></mat-icon>
                  <mat-icon *ngSwitchCase="'updated'" class="retrofit-task-icon accepted"><i class="fa-solid fa-cloud-arrow-up fa-sm"></i></mat-icon>
                </div>
                <div>
                  <div class="retrofit-task-name">{{taskRetrofitContractorTitle}}</div>
                  <span [ngSwitch]="taskRetrofitContractorStatus.toLowerCase()">
                    <small class="retrofit-task-status"
                      *ngSwitchCase="'pending'">
                      Waiting for information
                    </small>
                    <small class="retrofit-task-status"
                      *ngSwitchCase="'rejected'">
                      Action required
                    </small>
                    <small class="retrofit-task-status accepted"
                      *ngSwitchCase="'selected'">
                      Completed
                    </small>
                    <small class="retrofit-task-status"
                      *ngSwitchDefault>
                      {{taskRetrofitContractorStatus}}
                  </small>
                  </span>
                </div>
              </mat-panel-title>
              <mat-panel-description fxShow.gt-sm="true" fxShow="false">
                <span class="retrofit-task-summary todo">
                    {{taskRetrofitContractorSummary}}
                </span>
              </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="retrofit-task-body">
            <div fxLayout="row" fxLayout.lt-md="column wrap">
              <div fxFlex='75%'>
                <ebb-portal-contractor-form
                  [application]="application"
                  [taskBuildingPermit]="taskBuildingPermit"
                  [task]="taskBuildingPermit"
                  (emitContractorUpdateEvent)="onEmitContractorUpdate($event)">
                  (emitContractorFileUploadEvent)="onEmitContractorFileUploadEvent($event)"
                  (emitBidInvoiceFileUploadEvent)="onEmitBidInvoiceFileUploadEvent($event)">
                </ebb-portal-contractor-form>
              </div>

              <div fxFlex='25%'>
                <p class="retrofit-task-help-title" fxShow fxHide.lt-md>
                  Help
                </p>

                <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>

                <div *ngFor="let helpLink of helpByTopic('construction')">
                    <a class="retrofit-task-help-section-link"
                      href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                        {{helpLink.linkText}}
                    </a>
                </div>
              </div>
            </div>
          </div>

      </mat-expansion-panel>

      <!--Permit info-->
      <mat-expansion-panel *ngIf="taskBuildingPermit"
        [expanded]="viewApprovalTask === 1"
        (opened)="setApprovalTask(1)">
          <mat-expansion-panel-header
            [collapsedHeight]="'60px'"
            [expandedHeight]="'60px'">
              <mat-panel-title>
                <mat-icon class="retrofit-task-icon"
                  [ngClass]="{'accepted':
                                (taskBuildingPermit.statusCode === 700000001 || taskBuildingPermit.statusCode === 700000003),
                              'rejected': taskBuildingPermit.statusCode === 700000002,
                              'primary': true  }">
                              <div [innerHTML]="loadTaskStatusIconHtml('permit', taskBuildingPermit.statusCode)"></div>
                 
                </mat-icon>
                <div>
                  <div class="retrofit-task-name">{{taskBuildingPermit.name}}</div>
                  <small class="retrofit-task-status">
                    {{loadTaskStatusValue('permit', taskBuildingPermit.statusCode)}}
                  </small>
                </div>
              </mat-panel-title>
              <mat-panel-description fxShow.gt-sm="true" fxShow="false">
                <span class="retrofit-task-summary todo">
                  <span *ngIf="taskBuildingPermit.statusCode === 700000000 || !application.permitIssuer">
                    {{taskBuildingPermit.userPrompt}}
                  </span>
                  <span *ngIf="application.permitIssuer && application.permitIssuer.length > 0">
                      {{application.permitIssuer}} ({{application.permitNumber}})
                  </span>
                </span>
              </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
            <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
              <div fxFlex='75%'>

             
                <ebb-portal-file-list
                  [context]="'Review'"
                  [title]="'Building Permit Files'"
                  [application]="application"
                  [task]="taskBuildingPermit"
                  (emitFileUploadEvent)="onEmitFileUploadEvent($event)">
                </ebb-portal-file-list>

                <ebb-portal-permit-form
                  [application]="application"
                  [task]="taskBuildingPermit"
                  [permitPlanTypeOptions]="permitPlanTypeOptions"
                  (emitPermitInfoChangeEvent)=onEmitPermitUpdate($event)>
                </ebb-portal-permit-form>

                <!-- Moved inline form to child component -->
              </div>

              <div fxFlex='25%'>
                <p class="retrofit-task-help-title" fxShow fxHide.lt-md>Help</p>

                <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>

                <div div *ngFor="let helpLink of helpByTopic('permit')">
                  <a class="retrofit-task-help-section-link"
                     href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                       {{helpLink.linkText}}
                  </a>
                </div>
              </div>
            </div>
          </div>
      </mat-expansion-panel>

            <!--Permit signoff-->
            <mat-expansion-panel *ngIf="taskPermitSignoff"
            [expanded]="viewApprovalTask === 2"
            (opened)="setApprovalTask(2)">
              <mat-expansion-panel-header
                [collapsedHeight]="'60px'"
                [expandedHeight]="'60px'">
                  <mat-panel-title>
                    <mat-icon class="retrofit-task-icon"
                      [ngClass]="{'accepted':
                                  (taskPermitSignoff.statusCode === 700000001 || taskPermitSignoff.statusCode === 700000003),
                                  'rejected': taskPermitSignoff.statusCode === 700000002,
                                  'primary': true  }">
                                  <div [innerHTML]="loadTaskStatusIconHtml('permit', taskPermitSignoff.statusCode)"></div>
                                  
                    </mat-icon>

                    <div>
                      <div class="retrofit-task-name">{{taskPermitSignoff.name}}</div>
                      <small class="retrofit-task-status">
                        {{loadTaskStatusValue('permit', taskPermitSignoff.statusCode)}}
                      </small>
                    </div>

                  </mat-panel-title>
                  <mat-panel-description fxShow.gt-sm="true" fxShow="false">
                    <span class="retrofit-task-summary todo">
                      {{taskPermitSignoff.userPrompt}}
                    </span>
                  </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
                <div fxLayout="row" fxLayout.lt-sm="column wrap" fxLayoutGap="40px">
                  <div fxFlex='75%'>
                    <p class="retrofit-task-item-title">Permit Documents</p>
                    <ebb-portal-file-list
                      [context]="'Review'"
                      [title]="'Building Permit Files'"
                      [application]="application"
                      [task]="taskPermitSignoff"
                      (emitFileUploadEvent)="onEmitFileUploadEvent($event)">
                    </ebb-portal-file-list>

                    <div style='margin: 21px 0px;' readonly>
                      <ebb-portal-timespan-form
                        [application]="application"
                        [task]="taskPermitSignoff"
                        (eventEmitRetrofitTimespan)="onEmitTimeSpanFormUpdate($event)">
                      </ebb-portal-timespan-form>
                    </div>

                  </div>

                  <div fxFlex='25%'>
                    <p class="retrofit-task-help-title" fxShow fxHide.lt-sm>Help</p>
                    <div *ngFor="let helpLink of helpByTopic('permit')">
                      <a class="retrofit-task-help-section-link"
                         href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                           {{helpLink.linkText}}
                      </a>
                    </div>

                  </div>
                </div>
              </div>
          </mat-expansion-panel>

      <!--House photos Pre-retrofit-->
      <mat-expansion-panel *ngIf="taskHousePhotosPre"
        [expanded]="viewApprovalTask === 3"
        (opened)="setApprovalTask(3)">
          <mat-expansion-panel-header
            [collapsedHeight]="'60px'"
            [expandedHeight]="'60px'">
              <mat-panel-title>
                <mat-icon class="retrofit-task-icon"
                  [ngClass]="{'accepted':
                                (taskHousePhotosPre.statusCode === 700000001 || taskHousePhotosPre.statusCode === 700000003),
                              'rejected': taskHousePhotosPre.statusCode === 700000002,
                              'primary': true  }">
                              <div [innerHTML]="loadTaskStatusIconHtml('house', taskHousePhotosPre.statusCode)"></div>
                
                </mat-icon>
                <div>
                  <div class="retrofit-task-name">{{taskHousePhotosPre.name}}</div>
                  <small class="retrofit-task-status">
                    {{loadTaskStatusValue('house', taskHousePhotosPre.statusCode)}}
                  </small>
                </div>
              </mat-panel-title>
              <mat-panel-description  fxShow.gt-sm="true" fxShow="false">
                <span class="retrofit-task-summary todo">
                  {{taskHousePhotosPre.userPrompt}}
                </span>
              </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
            <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
              <div fxFlex='75%'>

                
                  <ebb-portal-photos
                    [application]="application"
                    [task]="taskHousePhotosPre"
                    (emitFileUploadEvent)="onEmitFileUploadEvent($event)">
                  </ebb-portal-photos>

              </div>

              <div fxFlex='25%'>
                <p class="retrofit-task-help-title" fxShow fxHide.lt-md>Help</p>

                <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>

                <div div *ngFor="let helpLink of helpByTopic('photos')">
                  <a class="retrofit-task-help-section-link"
                     href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                       {{helpLink.linkText}}
                  </a>
                </div>

              </div>
            </div>
          </div>
      </mat-expansion-panel>

            <!--House photos Post-retrofit-->
            <mat-expansion-panel *ngIf="taskHousePhotosPost"
            [expanded]="viewApprovalTask === 4"
            (opened)="setApprovalTask(4)">
              <mat-expansion-panel-header
                [collapsedHeight]="'60px'"
                [expandedHeight]="'60px'">
                  <mat-panel-title>
                    <mat-icon class="retrofit-task-icon"
                      [ngClass]="{'accepted':
                                  (taskHousePhotosPost.statusCode === 700000001 || taskHousePhotosPost.statusCode === 700000003),
                                  'rejected': taskHousePhotosPost.statusCode === 700000002,
                                  'primary': true  }">
                                  <div [innerHTML]="loadTaskStatusIconHtml('house', taskHousePhotosPost.statusCode)"></div>      
                    
                    </mat-icon>
                    <div>
                      <div class="retrofit-task-name">{{taskHousePhotosPost.name}}</div>
                      <small class="retrofit-task-status">
                        {{loadTaskStatusValue('house', taskHousePhotosPost.statusCode)}}
                      </small>
                    </div>
                  </mat-panel-title>
                      <mat-panel-description fxShow.gt-sm="true" fxShow="false">
                        <span [ngClass]="{
                                'retrofit-task-summary updated': taskHousePhotosPost.statusCodeOptionSet.toLowerCase() === 'approved',
                                'retrofit-task-summary todo': taskHousePhotosPost.statusCodeOptionSet.toLowerCase() !== 'approved'}">
                          {{taskHousePhotosPost.userPrompt}}
                        </span>
                      </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
                <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
                  <div fxFlex='75%'>
                 
                      <ebb-portal-photos
                        [application]="application"
                        [task]="taskHousePhotosPost"
                        (emitFileUploadEvent)="onEmitFileUploadEvent($event)">
                      </ebb-portal-photos>
                  </div>

                  <div fxFlex='25%'>
                    <p class="retrofit-task-help-title" fxShow fxHide.lt-md>Help</p>

                    <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>

                    <div div *ngFor="let helpLink of helpByTopic('photos')">
                      <a class="retrofit-task-help-section-link"
                         href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                           {{helpLink.linkText}}
                      </a>
                    </div>

                  </div>
                </div>
              </div>
          </mat-expansion-panel>

      <!--Crawl space photos Pre-retrofit-->
      <mat-expansion-panel *ngIf="taskCrawlspacePhotosPre"
        [expanded]="viewApprovalTask === 5"
        (opened)="setApprovalTask(5)">
          <mat-expansion-panel-header
            [collapsedHeight]="'60px'"
            [expandedHeight]="'60px'">
              <mat-panel-title>
                <mat-icon class="retrofit-task-icon"
                  [ngClass]="{'accepted':
                                (taskCrawlspacePhotosPre.statusCode === 700000001 || taskCrawlspacePhotosPre.statusCode === 700000003),
                              'rejected': taskCrawlspacePhotosPre.statusCode === 700000002,
                              'primary': true  }">
                              <div [innerHTML]="loadTaskStatusIconHtml('crawlspace', taskCrawlspacePhotosPre.statusCode)"></div>
        
                </mat-icon>
                <div>
                  <div class="retrofit-task-name">{{taskCrawlspacePhotosPre.name}}</div>
                  <small class="retrofit-task-status">
                    {{loadTaskStatusValue('crawlspace', taskCrawlspacePhotosPre.statusCode)}}
                  </small>
                </div>
              </mat-panel-title>
              <mat-panel-description  fxShow.gt-sm="true" fxShow="false">
                <span class="retrofit-task-summary todo">
                  {{taskCrawlspacePhotosPre.userPrompt}}
                </span>
              </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
            <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
              <div fxFlex='75%'>

              
                <ebb-portal-photos
                  [application]="application"
                  [task]="taskCrawlspacePhotosPre"
                  (emitFileUploadEvent)="onEmitFileUploadEvent($event)">
                </ebb-portal-photos>

              </div>

            <div fxFlex='25%'>
              <p class="retrofit-task-help-title" fxShow fxHide.lt-md>Help</p>

                <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>

                <div div *ngFor="let helpLink of helpByTopic('photos')">
                  <a class="retrofit-task-help-section-link"
                    href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                      {{helpLink.linkText}}
                  </a>
                </div>
              </div>
            </div>
          </div>
      </mat-expansion-panel>

      <!--Crawlspace photos Post-retrofit-->
      <mat-expansion-panel *ngIf="taskCrawlspacePhotosPost"
        [expanded]="viewApprovalTask === 6"
        (opened)="setApprovalTask(6)">
          <mat-expansion-panel-header
            [collapsedHeight]="'60px'"
            [expandedHeight]="'60px'">
              <mat-panel-title>
                <mat-icon class="retrofit-task-icon"
                [ngClass]="{'accepted':
                            (taskCrawlspacePhotosPost.statusCode === 700000001 || taskCrawlspacePhotosPost.statusCode === 700000003),
                            'rejected': taskCrawlspacePhotosPost.statusCode === 700000002,
                            'primary': true  }">
                            <div [innerHTML]="loadTaskStatusIconHtml('crawlspace', taskCrawlspacePhotosPost.statusCode)"></div>
                  
                </mat-icon>
                <div>
                  <div class="retrofit-task-name">{{taskCrawlspacePhotosPost.name}}</div>
                  <small class="retrofit-task-status">
                    {{loadTaskStatusValue('crawlspace', taskCrawlspacePhotosPost.statusCode)}}
                  </small>
                </div>
              </mat-panel-title>
              <mat-panel-description  fxShow.gt-sm="true" fxShow="false">
                <span class="retrofit-task-summary todo">
                  {{taskCrawlspacePhotosPost.userPrompt}}
                </span>
              </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
            <div fxLayout="row" fxLayout.lt-sm="column wrap" fxLayoutGap="25px">
              <div fxFlex='75%'>
                

                <ebb-portal-photos
                  [application]="application"
                  [task]="taskCrawlspacePhotosPost"
                  (emitFileUploadEvent)="onEmitFileUploadEvent($event)">
                </ebb-portal-photos>

              </div>
              <div fxFlex='25%'>
                <p class="retrofit-task-help-title" fxShow fxHide.lt-sm>Help</p>
                <div *ngFor="let helpLink of helpByTopic('photos')">
                  <a class="retrofit-task-help-section-link"
                     href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                       {{helpLink.linkText}}
                  </a>
                </div>

              </div>
            </div>
          </div>
      </mat-expansion-panel>

      <!--Water heater photos-->
      <mat-expansion-panel *ngIf="taskHeaterPhotos"
        [expanded]="viewApprovalTask === 7"
        (opened)="setApprovalTask(7)">
          <mat-expansion-panel-header
            [collapsedHeight]="'60px'"
            [expandedHeight]="'60px'">
              <mat-panel-title>
                <mat-icon class="retrofit-task-icon"
                [ngClass]="{'accepted':
                            (taskHeaterPhotos.statusCode === 700000001 || taskHeaterPhotos.statusCode === 700000003),
                            'rejected': taskHeaterPhotos.statusCode === 700000002,
                            'primary': true  }">
                            <div [innerHTML]="loadTaskStatusIconHtml('heater', taskHeaterPhotos.statusCode)"></div>  
                  
                </mat-icon>
                <div>
                  <div class="retrofit-task-name">{{taskHeaterPhotos.name}}</div>
                  <small class="retrofit-task-status">
                    {{loadTaskStatusValue('heater', taskHeaterPhotos.statusCode)}}
                  </small>
                </div>
              </mat-panel-title>
              <mat-panel-description  fxShow.gt-sm="true" fxShow="false">
                <span class="retrofit-task-summary todo">
                    {{taskHeaterPhotos.userPrompt}}
                </span>
              </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
            <div fxLayout="row" fxLayout.lt-sm="column wrap" fxLayoutGap="25px">
              <div fxFlex='75%'>
               
                <ebb-portal-photos
                  [application]="application"
                  [task]="taskHeaterPhotos"
                  (emitFileUploadEvent)="onEmitFileUploadEvent($event)">
                </ebb-portal-photos>
              </div>

              <div fxFlex='25%'>
                <p class="retrofit-task-help-title" fxShow fxHide.lt-sm>Help</p>
                <div *ngFor="let helpLink of helpByTopic('photos')">
                  <a class="retrofit-task-help-section-link"
                     href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                       {{helpLink.linkText}}
                  </a>
                </div>
              </div>
            </div>
          </div>
      </mat-expansion-panel>
     <!--receipts info-->
     <mat-expansion-panel *ngIf="taskReceiptsPre" [expanded]="viewApprovalTask === 8" id="receipts-info-panel" 
    (opened)="setApprovalTask('receipt')">
     <mat-expansion-panel-header [collapsedHeight]="'60px'" [expandedHeight]="'60px'">
       <mat-panel-title>
         <mat-icon class="retrofit-task-icon" [ngClass]="{'accepted':
         (taskReceiptsPre.statusCode === 700000001 || taskReceiptsPre.statusCode === 700000003),
       'rejected': taskReceiptsPre.statusCode === 700000002,
       'primary': true }">
       <div [innerHTML]="loadTaskStatusIconHtml('receipt', taskReceiptsPre.statusCode)"></div>

</mat-icon>
         <div>
           <div class="retrofit-task-name">{{taskReceiptsPre.name}}</div>
           <small [ngClass]="{'retrofit-task-status accepted': taskReceiptsPre.statusCode === 700000001,
                 'retrofit-task-status': true}">
             {{loadTaskStatusValue('receipt', taskReceiptsPre.statusCode)}}
           </small>
         </div>
       </mat-panel-title>
       <mat-panel-description fxShow.gt-sm="true" fxShow="false">
         <span class="retrofit-task-summary todo">
           {{taskReceiptsPre.userPrompt}}
           <span *ngIf="taskReceiptsPre.statusCode === 700000001 || taskReceiptsPre.statusCode === 700000003"
             class="retrofit-task-summary todo">
             (uploaded)
           </span>
         </span>
       </mat-panel-description>
     </mat-expansion-panel-header>
     <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
       <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
         <div fxFlex='75%'>

           
       

           <p class="retrofit-task-item-title">Retrofit Receipts</p>
           <ebb-portal-file-list [context]="'PreRetrofit'" [title]="'Retrofit Receipts'" [application]="application"
             [task]="taskReceiptsPre" (emitFileUploadEvent)="onEmitFileUploadEvent($event)">
           </ebb-portal-file-list>
           <ebb-portal-receipt-preretrofit-form
           [application]="application"
           [task]="taskReceiptsPre"
                     
           (emitReceiptPreretrofitFormChangeEvent)="onEmitReceiptsPreInfoUpdate($event)">
         </ebb-portal-receipt-preretrofit-form>
        

         </div>

         <div fxFlex='25%'>
           <p class="retrofit-task-help-title" fxShow fxHide.lt-md>Help</p>

           <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>

           <div div *ngFor="let helpLink of helpByTopic('receipts')">
             <a class="retrofit-task-help-section-link" href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
               {{helpLink.linkText}}
             </a>
           </div>
         </div>
       </div>
     </div>
   </mat-expansion-panel>
      <!-- Receipts -->
   <mat-expansion-panel *ngIf="taskReceiptsPost" [expanded]="viewApprovalTask === 9" (opened)="setApprovalTask(9)">
    <mat-expansion-panel-header [collapsedHeight]="'60px'" [expandedHeight]="'60px'">
      <mat-panel-title>
        <mat-icon class="retrofit-task-icon" [ngClass]="{
               'accepted':
               (taskReceiptsPost.statusCode === 700000001 || taskReceiptsPost.statusCode === 700000003),
               'rejected': taskReceiptsPost.statusCode === 700000002,
               'primary': true
             }">
             <div [innerHTML]="loadTaskStatusIconHtml('receipt', taskReceiptsPost.statusCode)"></div>
          
        </mat-icon>
        <div>
          <div class="retrofit-task-name">{{ taskReceiptsPost.name }}</div>
          <small class="retrofit-task-status">
            {{loadTaskStatusValue('receipt', taskReceiptsPost.statusCode)}}
          </small>
        </div>
      </mat-panel-title>
      <mat-panel-description fxShow.gt-sm="true" fxShow="false">
        <span class="retrofit-task-summary todo">
          {{ taskReceiptsPost.userPrompt }}
        </span>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
      <div fxLayout="row" fxLayout.lt-sm="column wrap" fxLayoutGap="12px">
        <div fxFlex="80%">
        
          <div style="margin-top: 15px;">
            <ebb-portal-receipt-list
             [title]="'Receipts'"
             [application]="application"
             [task]="taskReceiptsPost"
             (emitReceiptUploadEvent)="onEmitDataFormUpdate($event)">
            </ebb-portal-receipt-list>

           <div style="margin-top: 32px;">
             <ebb-portal-receipt-form
               [application]="application"
               [listOptionSets]="listOptionSets"
               [task]="taskReceiptsPost"
               (emitReceiptFormChangeEvent)="onEmitDataFormUpdate($event)">
             </ebb-portal-receipt-form>
           </div>

        </div>

        </div>
        <div fxFlex="20%">
          <p class="retrofit-task-help-title" fxShow fxHide.lt-sm>Help</p>
          <div *ngFor="let helpLink of helpByTopic('receipts')">
            <a class="retrofit-task-help-section-link" href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
              {{ helpLink.linkText }}
            </a>
          </div>
        </div>
      </div>
    </div>
   </mat-expansion-panel>

      <!--W-9 form-->
      <mat-expansion-panel *ngIf="!isContractor() && taskW9form && !isreadonly"
        [expanded]="viewApprovalTask === 10"
        (opened)="setApprovalTask(10)">
          <mat-expansion-panel-header
            [collapsedHeight]="'60px'"
            [expandedHeight]="'60px'">
              <mat-panel-title>
                <mat-icon class="retrofit-task-icon"
                  [ngClass]="{'accepted':
                                (taskW9form.statusCode === 700000001 || taskW9form.statusCode === 700000003),
                              'rejected': taskW9form.statusCode === 700000002,
                              'primary': true  }">
                              <div [innerHTML]="loadTaskStatusIconHtml('w9form', taskW9form.statusCode)"></div>   
                  
                </mat-icon>
                <div>
                  <div class="retrofit-task-name">{{taskW9form.name}}</div>
                  <small class="retrofit-task-status">
                    {{loadTaskStatusValue('w9form', taskW9form.statusCode)}}
                  </small>
                </div>
              </mat-panel-title>
              <mat-panel-description  fxShow.gt-sm="true" fxShow="false">
                <span class="retrofit-task-summary todo">
                    {{taskW9form.userPrompt}}
                </span>
              </mat-panel-description>
          </mat-expansion-panel-header>
            <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
              <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
                <div fxFlex='75%'>

                  <p class="retrofit-task-item-title">W-9 DATA</p>
                  <div class="retrofit-form-text">
                  <div [innerHTML]="w9message"></div>
                </div>

                  <div style="margin-top: 18px;"
                    *ngIf="(!application.eventPreliminaryReview ||
                           (application.eventPreliminaryReview && taskW9form.approvalTaskItems[0].statusCode === 700000002)) &&
                           isHomeowner()">
                    <button mat-stroked-button color="primary"
                    (click)="onClickSubmitW9data()">
                      SUBMIT FORM W-9 DATA
                    </button>
                  </div>

                  <div style="margin-top: 18px"
                    *ngIf="application.w9DataSubmitted
                          && taskW9form.approvalTaskItems[0].statusCode === 700000002
                          && (taskW9form.approvalTaskItems[0].reasonWhy
                              && taskW9form.approvalTaskItems[0].reasonWhy.length > 0)">
                    <p><span class="warn-text">Action required</span>: {{taskW9form.approvalTaskItems[0].reasonWhy}}</p>
                  </div>

                  <div class="retrofit-form-inline-icon-with-label-container"
                    *ngIf="w9FormSubmitted">
                      <mat-icon class="retrofit-form-inline-icon-with-label" color="accent">check_circle_outline</mat-icon>
                      <span class="retrofit-form-inline-icon-with-label-text">{{w9FormPayee}} W-9 data submitted on {{w9AuthorizationDate | date: 'M/d/yyyy'}}</span>
                  </div>

                </div>

                <div fxFlex='25%'>
                  <p class="retrofit-task-help-title" fxShow fxHide.lt-md>Help</p>

                  <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>

                  <div div *ngFor="let helpLink of helpByTopic('payment')">
                    <a class="retrofit-task-help-section-link"
                      href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                        {{helpLink.linkText}}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>


    <!--Payment authorization form-->
    <mat-expansion-panel *ngIf="!isContractor() && taskPaymentAuthorization && !isreadonly"
      [expanded]="viewApprovalTask === 11"
      (opened)="setApprovalTask(11)">
      <mat-expansion-panel-header
        [collapsedHeight]="'60px'"
        [expandedHeight]="'60px'">
        <mat-panel-title>
          <mat-icon class="retrofit-task-icon"
            [ngClass]="{'accepted':
                        (taskPaymentAuthorization.statusCode === 700000001 || taskPaymentAuthorization.statusCode === 700000003),
                        'rejected': taskPaymentAuthorization.statusCode === 700000002,
                        'primary': true  }">
                        <div [innerHTML]="loadTaskStatusIconHtml('payment', taskPaymentAuthorization.statusCode)"></div>      
             
          </mat-icon>
          <div>
            <div class="retrofit-task-name">{{taskPaymentAuthorization.name}}</div>
            <small class="retrofit-task-status">
              {{loadTaskStatusValue('payment', taskPaymentAuthorization.statusCode)}}
            </small>
          </div>
        </mat-panel-title>
        <mat-panel-description  fxShow.gt-sm="true" fxShow="false">
          <span class="retrofit-task-summary todo">
              {{taskPaymentAuthorization.userPrompt}}
          </span>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div class="retrofit-task-body" [ngClass]="{disabledDiv: isreadonly}">
        <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
          <div fxFlex='75%'>

            <p class="retrofit-task-item-title">PAYMENT FORM</p>
            <p>Authorize payment to either the homeowner or contractor.</p>
            <div
              *ngIf="isHomeowner() &&
                (!application.eventApplicationSubmitted ||
                (application.eventApplicationSubmitted && taskPaymentAuthorization.approvalTaskItems[0].statusCode === 700000002))"
              style="margin-top: 18px;">
              <button mat-stroked-button color="primary"
                (click)="onClickSubmitPaymentAuthorization()">
                  COMPLETE PAYMENT AUTHORIZATION
              </button>
            </div>

            <div style="margin-top: 18px"
              *ngIf="application.eventApplicationSubmitted
                    && taskPaymentAuthorization.approvalTaskItems[0].statusCode === 700000002
                    && (taskPaymentAuthorization.approvalTaskItems[0].reasonWhy
                        && taskPaymentAuthorization.approvalTaskItems[0].reasonWhy.length > 0)">
              <p><span class="warn-text">Action required</span>: {{taskPaymentAuthorization.approvalTaskItems[0].reasonWhy}}</p>
            </div>

            <div class="retrofit-form-inline-icon-with-label-container"
              *ngIf="authorizedPaymentSubmitted">
              <mat-icon class="retrofit-form-inline-icon-with-label" color="accent">check_circle_outline</mat-icon>
              <span class="retrofit-form-inline-icon-with-label-text">{{authorizedPaymentTo}} authorized</span>
            </div>
          </div>

          <div fxFlex='25%'>
            <p class="retrofit-task-help-title" fxShow fxHide.lt-md>Help</p>

            <mat-divider fxHide fxShow.lt-md style="margin: 9px 0;"></mat-divider>

            <div div *ngFor="let helpLink of helpByTopic('payment')">
              <a class="retrofit-task-help-section-link"
                href="javascript:void(0)" (click)="onClickShowHelp(helpLink)">
                  {{helpLink.linkText}}
              </a>
            </div>
          </div>
         </div>
      </div>
    </mat-expansion-panel>

    </mat-accordion>
  </section>

  <br/>

</div>
